export default "__VITE_ASSET__CYqc5VkR__"